














import {Component, Vue} from 'vue-property-decorator';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import {NameValues, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {
  pointTypeEnum, typeDistanceReport,
  TypeRequestReportRouteEnum
} from '@/modules/neodash/pages/nearestReports/types';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import {i18nMixin} from '@/modules/neodash/mixins';
import {FormFilterFields} from '@/modules/neodash/model/types/interfaces/FormFilterFields';
import {typeReports} from '@/modules/neodash/pages/nearestReports/constants';

interface labelPoint {
  type: pointTypeEnum;
  keyLabelSingularForm: string;
  keyLabelPluralForm: string;
}

@Component({
  name: 'NearestReportsFilter',
  components: {FilterDropDown, FilterContainer}
})
export default class NearestReportsFilter extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  public readonly keyLabelFrom: string = 'Common.From';
  public readonly keyLabelTo: string = 'Common.To';

  public readonly labelsPointType: labelPoint[] = [
    {
      type: pointTypeEnum.store,
      keyLabelSingularForm: 'Common.Store',
      keyLabelPluralForm: 'Common.Stores'
    },
    {
      type: pointTypeEnum.city,
      keyLabelSingularForm: 'Common.City',
      keyLabelPluralForm: 'Common.Cities'
    },
    {
      type: pointTypeEnum.operationalArea,
      keyLabelSingularForm: 'Filters.LocationType.OperationalArea',
      keyLabelPluralForm: 'Filters.LocationType.OperationalAreas'
    }
  ];

  public chosenFromType: OptionalNameValue = null;
  public chosenToType: OptionalNameValue = null;

  public get fromTypes(): NameValues {
    return this.listPointTypes(x => x.from, x => x.keyLabelSingularForm);
  }

  public get toTypes(): NameValues {
    return this.listPointTypes(x => x.to, x => x.keyLabelPluralForm);
  }

  public listPointTypes(getField: (obj: typeDistanceReport<any>) => pointTypeEnum, getKeyLabel: (obj: labelPoint) => string): NameValues {
    return typeReports
        .distinctBy(getField)
        .map(x => {
          const pointType = getField(x);
          const label = this.labelsPointType.findOrFirst(x => x.type === pointType);

          return {
            name: getKeyLabel(label),
            value: pointType
          }
        })
        .map(({name, value}) => ({name: this.translate(name), value}))
  }

  public get formValid(): boolean {
    const {chosenFromType, chosenToType} = this;
    if (!chosenFromType || !chosenToType)
      return false;

    return !!chosenFromType.value && !!chosenToType.value
  }

  public emitNewValue(): void {
    const {chosenFromType, chosenToType} = this;

    if (!chosenFromType || !chosenToType)
      return;

    const {keyLabelTo, keyLabelFrom, translate} = this;

    const result: FormFilterFields<TypeRequestReportRouteEnum> = {
      labels: [
        {text: translate(keyLabelFrom), value: chosenFromType.name},
        {text: translate(keyLabelTo), value: chosenToType.name},
      ].filter(x => !!x.value),
      value: this.typeReport
    };

    this.$emit('input', result);
  }

  private get typeReport(): TypeRequestReportRouteEnum {
    const {chosenFromType, chosenToType} = this;
    if (!chosenFromType || !chosenToType)
      return typeReports[0].type;

    return typeReports.findOrFirst(x => x.from === chosenFromType.value && x.to === chosenToType.value).type;
  }
}
